export default "__VITE_ASSET__1b50a309__"